import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Dealers from "./pages/Dealers";
import About from "./pages/About";
import Contact from "./pages/Contact";
import MentionsLegales from "./pages/MentionsLegales";
import NotFound from "./pages/NotFound";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import PolitiqueConfidentialite from "./pages/PolitiqueDeConfidentialite";
import ConditionsGenerales from "./pages/ConditionsGenerales";
import Breadcrumb from "components/breadcrumb/Breadcrumb";
import { BreadcrumbProvider } from "components/breadcrumb/BreadcrumbContext";
import { GlobalSEO } from "components/globalSEO";
import { HelmetProvider } from "react-helmet-async";

export default function App() {
  return (
    <HelmetProvider>
      <GlobalSEO />
      <BreadcrumbProvider>
        <div className="App">
          <Navbar />
          <main id="contenu" className="main container" role="main">
            <Breadcrumb />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/produits" element={<Products />} />
              <Route path="/produits/:slug" element={<ProductDetail />} />
              <Route path="/revendeurs" element={<Dealers />} />
              <Route path="/a-propos" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route
                path="/politique-confidentialite"
                element={<PolitiqueConfidentialite />}
              />
              <Route
                path="/conditions-generales"
                element={<ConditionsGenerales />}
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </BreadcrumbProvider>
    </HelmetProvider>
  );
}
